class WishlistManager {
  constructor() {
    this.storageKey = 'handmade_wishlist';
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateWishlistButtons();
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[class*="product-card-wishlist-btn"]')) {
        e.preventDefault();
        e.stopPropagation();
        const button = e.target.closest('[class*="product-card-wishlist-btn"]');
        const productId = button.dataset.productId;
        this.toggleWishlist(productId, button);
      }
    });
  }

  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error('Error reading wishlist from localStorage:', error);
      return [];
    }
  }

  saveWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    } catch (error) {
      console.error('Error saving wishlist to localStorage:', error);
    }
  }

  isInWishlist(productId) {
    const wishlist = this.getWishlist();
    return wishlist.includes(productId.toString());
  }

  addToWishlist(productId) {
    const wishlist = this.getWishlist();
    if (!wishlist.includes(productId.toString())) {
      wishlist.push(productId.toString());
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  }

  removeFromWishlist(productId) {
    const wishlist = this.getWishlist();
    const index = wishlist.indexOf(productId.toString());
    if (index > -1) {
      wishlist.splice(index, 1);
      this.saveWishlist(wishlist);
      return true;
    }
    return false;
  }

  toggleWishlist(productId, button) {
    if (this.isInWishlist(productId)) {
      this.removeFromWishlist(productId);
      button.classList.remove('active');
      button.setAttribute('aria-label', 'Add to wishlist');
    } else {
      this.addToWishlist(productId);
      button.classList.add('active');
      button.setAttribute('aria-label', 'Remove from wishlist');
    }
  }

  updateWishlistButtons() {
    const buttons = document.querySelectorAll('[class*="product-card-wishlist-btn"]');
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      if (this.isInWishlist(productId)) {
        button.classList.add('active');
        button.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  getWishlistCount() {
    return this.getWishlist().length;
  }

  clearWishlist() {
    this.saveWishlist([]);
    this.updateWishlistButtons();
  }
}

// Initialize wishlist manager when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.wishlistManager = new WishlistManager();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.wishlistManager = new WishlistManager();
  });
} else {
  window.wishlistManager = new WishlistManager();
}

class ProductCardCartManager {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  handleFormSubmit(e) {
    if (!e.target.matches('.\\#product-card-add-form')) return;

    e.preventDefault();
    const form = e.target;
    const button = form.querySelector('.\\#product-card-add-btn');

    this.addToCart(form, button);
  }

  addToCart(form, button) {
    this.setLoading(button, true);

    const formData = new FormData(form);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        // Dispatch updateCart event which the theme listens to (in modal.js)
        // The theme executes the callback after updating the cart HTML
        document.dispatchEvent(new CustomEvent('updateCart', {
          bubbles: true,
          detail: {
            callback: () => {
              this.setLoading(button, false);
              // Dispatch openPopup to open the cart drawer
              document.dispatchEvent(new CustomEvent('openPopup', {
                bubbles: true,
                detail: {
                  target: 'CART'
                }
              }));
            }
          }
        }));
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        this.setLoading(button, false);
      });
  }

  setLoading(button, isLoading) {
    const textSpan = button.querySelector('.\\#product-card-add-btn-text');
    const spinnerSpan = button.querySelector('.\\#product-card-add-btn-spinner');

    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      if (textSpan) textSpan.hidden = true;
      if (spinnerSpan) spinnerSpan.hidden = false;
    } else {
      button.removeAttribute('disabled');
      if (textSpan) textSpan.hidden = false;
      if (spinnerSpan) spinnerSpan.hidden = true;
    }
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.productCardCartManager = new ProductCardCartManager();
  });
} else {
  // DOM is already ready
  window.productCardCartManager = new ProductCardCartManager();
}